import { CookieHelper } from '../../helpers/CookieHelper';
import {
  useActiveBlockVersionFromCookie,
  setCookieQuery,
} from '../../hooks/useActiveBlockVersionFromCookie';
import { PanelFooterProps } from './PanelWrapper';

// Can we clean up this file and make it easier to follow?

const hasBlockQueryParam = (url: string) => {
  return url.indexOf('&block-') !== -1;
};

const getPathWithOutQueryString = (url: string) => {
  return url.split('?')[0];
};

const clearQueryString = () => {
  if (hasBlockQueryParam(window?.location?.search)) {
    const path = getPathWithOutQueryString(window.location.href);
    window.location.href = path;
  } else return;
};

export const doPlay = (
  selected: PanelFooterProps['selected'],
  setLoading: React.Dispatch<React.SetStateAction<boolean>>
) => {
  if (!selected) return;

  const cookieQuery = CookieHelper.GetCookie('x-block-config');
  const { blockId } = selected || {};

  const win: Window = window;
  if (win) win.location = win.location.href;

  if (!cookieQuery) {
    setCookieQuery(selected, '');
  } else {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { name } = useActiveBlockVersionFromCookie(blockId);
    if (name === blockId) {
      // Split **EXISTING COOKIE**
      const splitQuery = cookieQuery?.split('&');
      // Removing Block Version that already **EXISTS**
      const updatedSplitQuery = splitQuery?.filter(el => {
        if (!el.includes(name)) return true;
      });
      // Add / Update to **NEW** query
      if (updatedSplitQuery?.length >= 1) {
        const prevQuery = updatedSplitQuery.join('&');
        setCookieQuery(selected, prevQuery);
      } else {
        setCookieQuery(selected, '');
      }
    } else {
      setCookieQuery(selected, '');
    }
  }

  clearQueryString();
  setTimeout(() => {
    setLoading(false);
    location?.reload();
  }, 400);
};

export const getCanProceed = (
  selected: PanelFooterProps['selected'],
  setDisabled: React.Dispatch<React.SetStateAction<boolean>>
) => {
  const { defaultSelected, blockId } = selected || {};
  
  if (!blockId) return;

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { branch, version } = useActiveBlockVersionFromCookie(blockId);

  if (selected) {
    const selectedBranch = selected?.id;
    const selectedVersion = selected?.versionNo;

    if (
      !defaultSelected &&
      (selectedBranch !== branch ||
        parseInt(selectedVersion) !== parseInt(version))
    ) {
      setDisabled(false);
    }
    if (
      defaultSelected &&
      (selectedBranch !== branch ||
        parseInt(selectedVersion) !== parseInt(version))
    ) {
      setDisabled(false);
    }
    if (
      !defaultSelected &&
      selectedBranch === branch &&
      (parseInt(selectedVersion) === parseInt(version) || !version)
    ) {
      setDisabled(true);
    }
    if (
      defaultSelected &&
      selectedBranch === branch &&
      parseInt(selectedVersion) === parseInt(version)
    ) {
      setDisabled(true);
    }
    if (defaultSelected && !branch && !version) setDisabled(true);
    if (!defaultSelected && !branch && !version) setDisabled(false);
  }
};
